/* global $, turnstile */
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

declare const turnstile: any;

@ModuleName("ConsentDocuments")
export class ConsentDocuments implements AxInit {
    checkBoxInfos: ICheckboxInfo[] = [];
    consentNeeded: boolean = false;

    AxInit(init): void {
        $('.input-consent-doc-checkbox').on('change', () => this.evaluateConentDocCheckBoxes());
        this.initGuestPurchaseTerms();
    }

    initGuestPurchaseTerms() {
        if ($('#guestPurchaseTerms').length > 0) {
            const $altcha: any = $("#altcha");
            $('body').on('change', '#guestPurchaseTerms', (e) => {
                const isChecked: boolean = $(e.currentTarget).is(':checked');
                const isAltchaVerified: boolean = ($altcha.length > 0 && $altcha.get(0).getState() === 'verified') || $altcha.length === 0;
                const isTurnstileValid: boolean = (typeof turnstile !== 'undefined' && turnstile?.getResponse()) || typeof turnstile === 'undefined';
                const $consentButton = $('[data-checkout="guest"]');
                $consentButton.prop('disabled', !(isChecked && isAltchaVerified && isTurnstileValid));
            });
        }
    }

    evaluateConentDocCheckBoxes() {
        this.checkBoxInfos = [];

        $(".input-consent-doc-submit-button").prop('disabled', false);
        $('.input-consent-doc-checkbox').each((_, el) => {
            this.consentNeeded = true;
            let consentDoc = {
                documentId: $(el).attr('id'),
                isChecked: false
            }
            if ($(el).hasClass('input-consent-doc-checkbox-mandatory') && !$(el).is(':checked')) {
                $(".input-consent-doc-submit-button").prop('disabled', true);
            }

            consentDoc.isChecked = $(el).is(':checked');
            this.checkBoxInfos.push(consentDoc);
        });
    }

    getActiveCheckboxes(): ICheckboxInfo[] {
        return this.checkBoxInfos;
    }

    getConsentNeeded(): boolean {
        return this.consentNeeded;
    }
}

export interface ICheckboxInfo {
    documentId: string;
    isChecked: boolean;
}